import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const GridItem = injectStyles({
  gridItem: {
    // PAD-822 mods, it's now been requests that there should only be one
    // column instead of two. This has been changed from 50% to 100%
    width: '100%',
    minWidth: 390,
    display: 'inline-block',
    boxSizing: 'border-box',
    paddingRight: 30,
    verticalAlign: 'top',
    marginBottom: 40,
  },
  inner: {
    overflow: 'auto',
    boxShadow: '-1px 1px 9px 3px #e2e1e1',
  },
})(props => {
  const { children, classes, className } = props
  return (
    <div className={classNames(classes.gridItem, className)}>
      <div className={classes.inner}>{children}</div>
    </div>
  )
})

export default GridItem
